<script>
    import {getContext} from 'svelte';
    import Popup from './Popup.svelte';

    export let formTitle;
    export let buttonText;
    export let buttonClass;

    const {open} = getContext('simple-modal');
    const openModal = () => {
        open(Popup, {formTitle});
    };
</script>

<button type="button"
        class={buttonClass}
        title={buttonText}
        on:click={openModal}>
    {buttonText}
</button>
